<template>
  <thead class="bg-info" :class="tableHeadRoleGuest ? 'tableheader-sticky-guest' : 'tableheader-sticky'">
    <tr class="align-middle">
      <th v-for="(header,index) in headers" scope="col" role="button" :key="index" @click="$emit('sort', header.column)">
        <div class="d-flex justify-content-center align-items-center">
          {{ header.label }}
          <i v-if="header.column === sort.column"
             :class="['ms-1', sort.ascending ? 'cil-sort-ascending' : 'cil-sort-descending']"
          />
        </div>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: "TableHead",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    sort: {
      type: Object,
      required: true,
    }
  },
  computed: {
    tableHeadRoleGuest() {
      return this.$store.state.account.is_guest;
    },
  },
  emits: ['sort'],
}
</script>
